<ul class="ob1-item-card-list mt-2 mb-0">
  @for (warning of warnings; track warning) {
    <li>
      <ng-container
        [ngTemplateOutlet]="warning.link ? interactiveWarn : simpleWarn"
        [ngTemplateOutletContext]="{ warning: warning }"
      >
      </ng-container>
    </li>
  }
</ul>

<ng-template #interactiveWarn let-warning="warning">
  <div
    class="alert-container ob1-notification-message alert-warning mb-0"
    [attr.data-e2e]="'e2e-push-warning-' + warning?.code"
  >
    <a
      ecmPushTracker
      [ecmDisabledAction]="isEclair && !AdviseWhitelistEclairConstants.WHITELIST.includes(warning.code?.toUpperCase())"
      [attr.data-e2e]="'e2e-push-warning-btn-' + warning?.code"
      [attr.id-ref-zone]="warning?.idRefZone"
      [pdb-zid]="zid"
      [pdb-sc]="'adv'"
      [pdb-ta]="warning.advTracker"
      [pdb-idc]="warning.code"
      [href]="warning.href"
      (click)="openLink(warning); (false)"
      class="ob1-item-card alert-warning px-1 px-md-1 no-border"
    >
      @if (warning.imageUrl) {
        <img alt="" class="push-warn-icon" src="{{ getImgFormat(warning.imageUrl) }}" />
      } @else {
        <span class="icon icon-Warning-important push-warn-icon" aria-hidden="true"></span>
      }
      <div class="ob1-item-card-container anchor-color">
        <div class="ob1-item-card-text">
          <strong>{{ warning.title }}</strong>
          <small class="ob1-item-card-desc push-warn-desc text-mw">
            {{ warning.content }}
          </small>
        </div>
      </div>
    </a>
  </div>
</ng-template>
<ng-template #simpleWarn let-warning="warning">
  <div
    class="alert-container ob1-notification-message alert-warning no-border mb-0"
    [attr.data-e2e]="'e2e-push-warning-' + warning?.code"
  >
    <div class="ob1-item-card alert-warning px-1 px-md-1">
      <img alt="" class="push-warn-icon" src="{{ getImgFormat(warning.imageUrl) }}" />
      <div class="ob1-item-card-container anchor-color">
        <div class="ob1-item-card-text">
          <strong>{{ warning.title }}</strong>
          <small class="ob1-item-card-desc push-warn-desc text-mw">
            {{ warning.content }}
          </small>
        </div>
      </div>
    </div>
  </div>
</ng-template>
